import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  paper: {
    backgroundColor: theme.palette.background.paper,
    border: `2px solid ${theme.palette.secondary.main}`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    minWidth: '60vw',

  },
  topBarWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative',
  },

  button: {
    fontSize: '10px',
    margin: theme.spacing(1, 1),
    color: theme.palette.white.main,
    background: theme.palette.secondary.main,
    border: 'none',

    '&:hover': {
      background: theme.palette.secondary.dark,
    },
  },

  verticalTable: {
    display: 'flex',
    flexDirection: 'column',

    '& tr': {
      width: '100%',
    },

    '& th': {
      fontWeight: '600',
      fontSize: '0.9rem',
      width: '100%',
    },

    '& th, & td': {
      display: 'flex',
      alignItems: 'center',
      border: `1px solid ${theme.palette.border.main}`,
      lineHeight: '1.5rem',
      width: '100%',
      height: '80px',
    },
  },

  horizontalTable: {
    display: 'flex',

    '& th': {
      fontWeight: '600',
      fontSize: '0.9rem',
      width: '100%',
    },

    '& tr': {
      width: '100%',
    },

    '& th, & td': {
      display: 'flex',
      alignItems: 'center',
      border: `1px solid ${theme.palette.border.main}`,
      lineHeight: '1.5rem',
      width: '100%',
      height: '80px',
    },
  },
}));

export default useStyles;
